import clsx from "clsx"

const Game = ({
  score,
  players,
  showShareButton = false,
}: {
  score: string
  players: string
  showShareButton?: boolean
}) => (
  <div className="relative flex w-full items-center justify-between rounded-2xl border border-gray-200 bg-white px-5 py-3 shadow-md sm:px-6">
    <div className="flex items-center text-sm text-gray-600 sm:text-base">
      <div className="w-10 text-chessdrop-500 sm:w-12">{score}</div>
      <div
        className={clsx("line-clamp-1", {
          "text-sm lg:text-base": showShareButton,
        })}
      >
        {players}
      </div>
    </div>
    {showShareButton && (
      <div className="rounded-xl bg-chessdrop-500 px-3 py-1.5 text-sm font-medium text-white">
        Share
      </div>
    )}
  </div>
)

export default Game
